<section class="edit-invitados">
  <header>
    <h3>Registrar nuevo invitado</h3>
  </header>

  <form [formGroup]="invitados_group" class="full-width">
    <ul>
      <li class="double">
        <mat-form-field class="form-control" focused cdkFocusInitial formGroupName="dni_validation_group">
          <mat-label><span i18n="@@web-inscripciones.dni">DNI</span></mat-label>
          <input matInput type="text" formControlName="dni" uppercase>
          @if (ctrl_dni.touched &&
            ctrl_dni.errors &&
            ctrl_dni.errors.required) {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-dni">Introduzca su DNI</span>
            </mat-hint>
          }
          @if (invitados_group.get('dni_validation_group')!.errors &&
            invitados_group.get('dni_validation_group')!.errors!.DNIExiste) {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.dni-ya-existente">DNI ya existente (¿Invitado duplicado?)</span>
            </mat-hint>
          }
          <!--                    <pre>{{ctrl_dni.errors|json}}</pre>
          <pre>{{invitados_group.get('dni_validation_group')!.errors|json}}</pre>-->

        </mat-form-field>
        <div class="">
          <mat-slide-toggle color="primary" formControlName="acto_social">
            @if (this.invitados_group.controls.acto_social.value) {
              <span i18n="@@web-inscripciones.si">Sí </span>
            }
            @if (!this.invitados_group.controls.acto_social.value) {
              <span i18n="@@web-inscripciones.no">No </span>
            }
            <span i18n="@@web-inscripciones.asistira-acto-social">asistirá acto social</span>
          </mat-slide-toggle>
        </div>
      </li>
      <li>
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.nombre">Nombre</span></mat-label>
          <input matInput type="text" formControlName="nombre">
          @if (this.invitados_group.controls.nombre.touched && this.invitados_group.controls.nombre.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-name">Introduzca su name</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
      <li class="double">
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.apellido1">Apellido 1</span></mat-label>
          <input matInput type="text" formControlName="apellido1">
          @if (this.invitados_group.controls.apellido1.touched && this.invitados_group.controls.apellido1.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-primer-apellido">Introduzca su primer apellido</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.apellido2">Apellido 2</span></mat-label>
          <input matInput type="text" formControlName="apellido2">
          @if (this.invitados_group.controls.apellido2.touched && this.invitados_group.controls.apellido2.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-segundo-apellido">Introduzca su segundo apellido</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
      <li class="double">
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.email">Email</span></mat-label>
          <input matInput type="email" formControlName="email">
          @if (this.invitados_group.controls.email.touched && this.invitados_group.controls.email.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.please-entar-a-valid-email">Please entar a valid eMail</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.telefono">Teléfono</span></mat-label>
          <input matInput type="text" formControlName="telefono">
          @if (this.invitados_group.controls.telefono.touched && this.invitados_group.controls.telefono.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-telefono">Introduzca su Teléfono</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
      <li>
        <mat-form-field class="form-control">
          <mat-label><span i18n="@@web-inscripciones.direccion">Dirección</span></mat-label>
          <input matInput type="text" formControlName="direccion">
          @if (this.invitados_group.controls.direccion.touched && this.invitados_group.controls.direccion.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-direccion">Introduzca su direccion</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
      <li class="double">
        <mat-form-field class="form-control" style="width:10em;">
          <mat-label><span i18n="@@web-inscripciones.codigo_postal">Código_postal</span></mat-label>
          <input matInput type="text" formControlName="codigo_postal">
          @if (this.invitados_group.controls.codigo_postal.touched && this.invitados_group.controls.codigo_postal.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-codigo-postal">Introduzca su código postal</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label><span i18n="@@web-inscripciones.ciudad">Ciudad</span></mat-label>
          <input matInput type="text" formControlName="ciudad">
          @if (this.invitados_group.controls.ciudad.touched && this.invitados_group.controls.ciudad.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-ciudad">Introduzca su ciudad</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label><span i18n="@@web-inscripciones.pais">País</span></mat-label>
          <input matInput type="text" formControlName="pais">
          @if (this.invitados_group.controls.pais.touched && this.invitados_group.controls.pais.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-pais">Introduzca su pais</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
      <li>
      </li>
      <li class="double">
        <mat-form-field class="form-control" style="width:10em;">
          <mat-label><span i18n="@@web-inscripciones.tipo-empresa">Tipo empresa</span></mat-label>
          <input matInput type="text" formControlName="tipo_empresa">
          @if (this.invitados_group.controls.tipo_empresa.touched && this.invitados_group.controls.tipo_empresa.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-tipo-empresa">Introduzca su tipo empresa</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label><span i18n="@@web-inscripciones.empresa">Empresa</span></mat-label>
          <input matInput type="text" formControlName="empresa">
          @if (this.invitados_group.controls.empresa.touched && this.invitados_group.controls.empresa.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.please-entar-your-name">Please entar your name</span>
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field class="form-control" style="width:33%;">
          <mat-label><span i18n="@@web-inscripciones.cargo">Cargo</span></mat-label>
          <input matInput type="text" formControlName="cargo">
          @if (this.invitados_group.controls.cargo.touched && this.invitados_group.controls.cargo.status==='INVALID') {
            <mat-hint class="error-text">
              <span i18n="@@web-inscripciones.introduzca-su-cargo">Introduzca su cargo</span>
            </mat-hint>
          }
        </mat-form-field>
      </li>
    </ul>
    <nav mat-dialog-actions class="dialog-actions">
      <button mat-flat-button color="primary" (click)="close()">Cancelar</button>
      <button mat-flat-button color="primary"
        [disabled]="this.invitados_group.status==='INVALID'"
      [mat-dialog-close]="values" cdkFocusInitial>Guardar</button>
    </nav>
  </form>

</section>
